const React = require('react');
const {COUNTRIES_UPPERCASE} = require("../../../../constants/countries");

module.exports = (Select) => (props) => (
  <Select
    propName="0"
    propValue="1"
    items={COUNTRIES_UPPERCASE}
    {...props}
  />
)
